import { Component, OnInit } from '@angular/core';
import { Document, DocumentCategory, DocumentStatus } from '../../model/document';
import { User } from '../../model/user';
import { Company } from '../../model/company';
import { AuthenticationService } from '../../services/authentication.service';
import { DBService } from '../../services/db.service';
import { Router, ActivatedRoute } from '@angular/router';

import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

declare var Materialize: any;

@Component({
  selector: 'app-edit-document',
  templateUrl: './edit-document.component.html',
  styleUrls: ['./edit-document.component.css'],
  providers: [DBService,
    {provide: MAT_DATE_LOCALE, useValue: 'pt-br'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS}
  ]
})
export class EditDocumentComponent implements OnInit {

  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  document: Document;

  successMessage: string;
  errorMessage: string;

  initLoading: boolean;
  loading: boolean;

  expirationDate: string;

  categories: DocumentCategory[];

  selectedFile: File;

  user: User;

  companies: Company[];

  uid: string;

  userCompanyUID: string;

  constructor(private router: Router, private route: ActivatedRoute, private dbService: DBService, private authService: AuthenticationService, private adapter: DateAdapter<any>) {
    this.initLoading = true;
    this.document = new Document();

    if (!this.authService.isAdmin()) {
      this.userCompanyUID = this.authService.getUserCompany();
    }

    this.route.params
    .subscribe(params => this.initData(params['id']));
  }

  private initData(id: string) {
    this.uid = id;

    this.dbService.getObject<Document>(`documents/${this.uid}`)
      .then(document => {
        this.document = document;

        this.loadCategories();
      });
  }

  private loadCategories() {
    this.dbService.listWithUIDs<DocumentCategory>('documents-type')
    .then(categories => {
      this.categories = categories.sort((a, b) => a.description.localeCompare(b.description));

      this.loadData();
    });
   }

  private loadData() {
    this.user = this.authService.getUser();

    this.loadCompanies();
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        if (this.userCompanyUID) {
          this.companies = companies.filter(c => c.uid === this.userCompanyUID);
        } else {
          this.companies = companies;
        }

        this.initLoading = false;
        this.updateTextFields();
      });
  }

  private updateTextFields() {
    setTimeout(() => Materialize.updateTextFields(), 100);
  }

  ngOnInit() {
  }

  detectFiles(event) {
    this.selectedFile = event.target.files[0];
  }

  onChange(event) {
    const dateParts = this.document.expirationDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.document.expirationDate;
    } else {
      this.document.expirationDate = date.getTime();
    }
  }

  cancel() {
    this.router.navigate(['/documentos']);
  }

  private save() {
    this.loading = true;

    this.document.description = this.categories.filter(c => c.uid === this.document.category)[0].description;

    const updatingObj: any = {
      category: this.document.category,
      companyUID: this.document.companyUID,
      description: this.document.description,
      expirationDate: this.document.expirationDate,
      expirationDateString: this.document.expirationDateString,
      pending: this.document.pending
    };

    if (this.selectedFile) {
      updatingObj.fileURL = this.document.fileURL;
    }

    this.dbService.update(`documents/${this.uid}`, updatingObj)
    .then(() => this.saveSuccess())
    .catch(error => console.log(error));
  }

  private saveSuccess() {
    this.loading = false;

    Materialize.toast('Documento atualizado com sucesso', 2000);

    this.router.navigate(['/documentos']);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/edit-document/edit-document.component.ts